import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/Elements';
import * as z from 'zod';
import { useState } from 'react';
import { useNotificationStore } from '@/stores/notifications';
import img from '@/assets/new-logo.png';
import em from '@/assets/email-img.png';

export const PasswordChange = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <div className='changes-password'>
    <div className="p-5 register-form pass-changes">
   
      {/* <img src={img} width="70" alt="alttext" /> */}
      <img src={img} alt="logo" className="v-logo " />
      {/* <h1 className="mb-0 mt-3">Create New Password</h1> */}
      <div className="mt-4">
        <div className="password-verify-content">
          <div className="pass-img-box text-center">
            <img src={em} alt="email" className="mx-auto" />
          </div>
          <div className="pass-heading">
            <h3 className="mt-4 text-black mb-2" style={{fontSize: "32px"}}>Password Changed Successfully!</h3>
            <p style={{fontSize: "16px", color: "#000"}}>Your password has been changed successfully.</p>
            <div className="back-to-login-btn sign-btn mt-4 text-center ">
              <button
                type="button"
                className="btn rounded-10 w-50 fw-500"
                onClick={() => navigate('/auth/login-user')}
              >
                Back To Login
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};
